import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction'

import ReduxThunk from 'redux-thunk'

function configureStore(reducers, initialState) {
  const composeEnhancers = composeWithDevTools({
    // options like actionSanitizer, stateSanitizer
  })

  return createStore(
    reducers,
    initialState,
    composeEnhancers(applyMiddleware(ReduxThunk))
  )
}

export { configureStore }
